
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.12 23a.88.88 0 0 0 1.22 0L23 20.33a.88.88 0 0 0 0-1.22l-3.88-3.87a.86.86 0 0 0-.6-.25h-2.66a.86.86 0 0 0-.86.86v2.65a.86.86 0 0 0 .25.61Zm-3.95-7.66-1.85-1.85M12 18.24H3a.76.76 0 0 1-.75-.75v-7.25m13.5 0v1.75","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":".75","y":"5.99","width":"16.5","height":"4.25","rx":".75","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M9 18.24V5.99M4.73 3.87A11.84 11.84 0 0 0 9 6a11.93 11.93 0 0 0-2.14-4.25C5.54.43 4.79.63 4.2 1.22s-.78 1.33.53 2.65Zm8.54 0A11.84 11.84 0 0 1 9 6a11.93 11.93 0 0 1 2.12-4.24C12.46.43 13.21.63 13.8 1.22s.78 1.33-.53 2.65Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    